<template>
    <h2 v-if="title" class="text-base font-semibold leading-7 text-gray-900">
        <span>{{ title }}</span>
    </h2>
    <div class="mt-5 space-y-5">
        <slot />
    </div>
</template>

<script setup lang="ts">
defineProps<{ title?: string }>();
</script>
